import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext'; // Import useData
import { hasPermission } from '../utils/permissions'; // Import permission checker

const ProtectedRoute = ({ children, requiredPermission }) => {
    const { isAuthenticated, user } = useAuth();
    const { rolesPermissionsMap } = useData(); // <-- Get the map
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Use the map in the check
    if (requiredPermission && !hasPermission(user?.role, requiredPermission, rolesPermissionsMap)) {
        console.warn(`Access Denied (ProtectedRoute): Role='${user?.role}', Required='${requiredPermission}'`);
        // Optionally, show an Unauthorized page or component instead of redirecting
        // return <MainLayout><UnauthorizedPage /></MainLayout>;
        return <Navigate to="/dashboard" replace />; // Redirect to dashboard for now
    }

    // Render the child component if authenticated and authorized
    return children;
};

export default ProtectedRoute;

/* const ProtectedRoute = ({ children, requiredPermission }) => {
    const { isAuthenticated, user } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check for required permission if specified
    if (requiredPermission && !hasPermission(user?.role, requiredPermission)) {
            // Redirect to an unauthorized page or dashboard if permission denied
            console.warn(`Access denied for user ${user?.username} (role: ${user?.role}) to resource requiring permission: ${requiredPermission}`);
            // Optionally redirect to a specific 'Unauthorized' page
            // return <Navigate to="/unauthorized" replace />;
            // Or redirect to dashboard
            return <Navigate to="/dashboard" replace />;
    }


    return children;
};
export default ProtectedRoute;  */
// <--- Make sure this line is exactly like this and the file is saved
